import { render, staticRenderFns } from "./StockableItemImport.vue?vue&type=template&id=8fc72f82&"
import script from "./StockableItemImport.vue?vue&type=script&lang=ts&"
export * from "./StockableItemImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports